export default "__VITE_ASSET__DgXmSph0__"